import { createFrontendPlugin } from '@backstage/frontend-plugin-api';

import { PageBlueprint } from "@backstage/frontend-plugin-api";
import { Home } from '@mui/icons-material';
import { rootRouteRef } from './routes';

/**
 * @alpha
*/
export const homePageExtension = PageBlueprint.make({
    params: {
        title: 'Home',
        path: '/',
        noHeader: true,
        routeRef: rootRouteRef,
        loader: () => import('./components/HomePage').then(m => <m.HomePage />),
    },
});

export const customHomePlugin = createFrontendPlugin({
    icon: <Home fontSize="inherit"/>,
    pluginId: 'custom-home',
    title: 'Home',
    extensions: [homePageExtension],
    routes: {
        root: rootRouteRef
    }
});